import { apiConstants } from "../constants";
import { toast } from "../actions/toast.actions";

const api = ({ dispatch, getState }) => (next) => (action) => {
  if (action.type !== apiConstants.API) {
    return next(action);
  }
  const {
    url,
    success,
    failure,
    request,
    method,
    options,
    body,
    formatData,
    progress,
    redirect,
  } = action.payload;

  request && dispatch(request());
  showToast({ dispatch, progress, type: "request" });
  redirectHandler({ type: "request", redirect });

  const requestOptions = {
    method: method ? method : "GET",
    body: body ? JSON.stringify(body) : undefined,
    credentials: "include",
    ...options,
  };

  // Send request
  fetch(url, requestOptions).then((response) => {
    // Receive response
    const { ok, status } = response;
    if (status === 204) {
      const data = formatData ? formatData() : {};
      if (success) {
        dispatch(success(data));
      }
      showToast({ dispatch, progress, type: "success", data });
      redirectHandler({ type: "success", redirect });
    } else {
      // Parse JSON
      response
        .json()
        .then((json) => {
          const isSuccess = ok && status >= 200 && status < 204;
          if (isSuccess) {
            const data = formatData
              ? formatData(json.data)
              : { data: json.data };
            if (success) {
              dispatch(success(data));
            }
            showToast({ dispatch, progress, type: "success", data });
            redirectHandler({ type: "success", redirect, data });
          } else {
            const errorMessage = parseErrorMessage(json);
            dispatch(failure(errorMessage));
            showToast({ dispatch, progress, type: "failure", errorMessage });
            redirectHandler({ type: "failure", redirect });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  });
};

const parseErrorMessage = (data) => {
  const { errors, code } = data;
  if (errors && errors.message) {
    return errors.message;
  }
  if (code === 401) {
    return "Could not authenticate. Please enter a valid email and password.";
  }
};

const intentMap = {
  request: "loader",
  success: "success",
  failure: "error",
};

const redirectHandler = ({ redirect, type, data }) => {
  if (redirect && redirect[type]) {
    redirect[type](data);
  }
};

const showToast = ({ dispatch, progress, type, errorMessage = "", data }) => {
  if (type === "failure") {
    console.error(errorMessage);
    dispatch(toast({ intent: "error", message: errorMessage }));
  } else if (progress && progress[type]) {
    dispatch(
      toast({
        intent: progress[type].intent ? progress[type].intent : intentMap[type],
        message: progress[type].message
          ? progress[type].message(data)
          : errorMessage,
      })
    );
  }
};

export default api;



// WEBPACK FOOTER //
// ./src/redux/middleware/api.js